import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import {NotificationService} from "../../services/notification/notification.service";
import { ConfigurationService } from 'src/app/services/configuration.service';


@Component({
  selector: 'app-alerts-dsn',
  templateUrl: './alerts-dsn.component.html',
  styleUrls: ['./alerts-dsn.component.scss']
})
export class AlertsDsnComponent implements OnInit {

  gestionSalariesRoute = this.configurationService.get().dsn.gestionSalariesRoute;
  configuration = this.configurationService.get();
  constructor(protected notificationService: NotificationService, private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

  handleRejectEvent(_event: any) {
    const count: number = this.notificationService.countDsnNotificationSubject.getValue();
    if (_event && count > 0) {
      this.notificationService.countDsnNotificationSubject.next(count - 1);
    }
  }

  handleEmitUnreadNotificationsEvent(_event: any) {
    this.notificationService.countDsnNotificationSubject.next(_event ? _event :0);
  }
}
